import { Popover } from '@rocketlane/ui';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useCallback, useMemo } from 'react';
import { useVideoPlayerContext } from '../../player-context';

const playbackSpeeds = [0.75, 1, 1.25, 1.5, 2, 2.5, 3];

export const PlaybackSpeed = () => {
  const { playerRef } = useVideoPlayerContext();
  const playbackRate = useMediaState('playbackRate', playerRef!);
  const remote = useMediaRemote(playerRef);
  const selectedPlaybackSpeed = useMemo(() => {
    return playbackSpeeds.find(
      (speed) => Math.abs(speed - playbackRate) < 0.01,
    );
  }, [playbackRate]);
  const handleChangePlaybackSpeed = useCallback(
    (speed: number) => {
      remote.changePlaybackRate(speed);
    },
    [remote],
  );

  return (
    <Popover
      triggerMode="click"
      content={
        <div className="flex flex-col gap-02">
          {playbackSpeeds.map((speed) => (
            <div
              key={speed}
              className={`body-short-00 text-text-primary cursor-pointer py-02 px-03 rounded-4 hover:bg-[var(--scarlet-gray-100)]
            ${selectedPlaybackSpeed === speed ? 'bg-[var(--blue-20)]' : ''}
            `}
              onClick={() => handleChangePlaybackSpeed(speed)}
            >
              {speed}x
            </div>
          ))}
        </div>
      }
    >
      <div className="body-short-00 text-text-primary cursor-pointer flex items-center justify-center h-[32px] w-[32px]">
        {playbackRate}x
      </div>
    </Popover>
  );
};
